import { render } from "./HealthNoCoverage.vue?vue&type=template&id=12af96a7&ts=true"
import script from "./HealthNoCoverage.vue?vue&type=script&lang=ts"
export * from "./HealthNoCoverage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__